import { cn } from 'utils/bem';

export const profileMenu = cn('profile-menu');
